import { ref } from 'vue';
import { testimonialsService } from '@/services/testimonialsService';

export function useTestimonials() {
  const testimonials = ref([]);
  const testimonialsLoading = ref(true);
  const myTestimonial = ref(null);
  // UX-only hint from the backend (SubscriptionGate::canRate / equivalent) —
  // controls whether the rating form is shown, never trusted for enforcement.
  const canRate = ref(false);

  async function fetchTestimonials() {
    try {
      testimonialsLoading.value = true;
      testimonials.value = await testimonialsService.getAll();
    } catch {
      testimonials.value = [];
    } finally {
      testimonialsLoading.value = false;
    }
  }

  async function fetchMyTestimonial() {
    try {
      const result = await testimonialsService.getMine();
      myTestimonial.value = result.testimonial;
      canRate.value = result.canRate;
    } catch {
      myTestimonial.value = null;
      canRate.value = false;
    }
  }

  return {
    testimonials,
    testimonialsLoading,
    myTestimonial,
    canRate,
    fetchTestimonials,
    fetchMyTestimonial,
  };
}
